import { RouteName } from "@/lib/router/routes";

export default function (crewId: string) {
  return {
    name: RouteName.crew,
    params: {
      crewId,
    },
  };
}
